import { EnumPriceCalculationType } from '../../../../api/Argentia/enums'

/**
 * Normaliza el priceCalculationType para que siempre sea un valor numérico.
 * - Si recibe un string del enum (ej: "Fijo"), lo convierte al valor numérico (ej: 2)
 * - Si recibe un valor numérico, lo retorna tal cual
 * - Si es undefined/null, retorna undefined
 */
export const priceCalculationTypeMapper = (
  priceCalculationType: EnumPriceCalculationType | undefined
): EnumPriceCalculationType | undefined => {
  if (!priceCalculationType && priceCalculationType !== 0) return undefined

  // Si es un número, retornarlo directamente
  if (typeof priceCalculationType === 'number') {
    return priceCalculationType
  }

  // Si es un string (key del enum), convertirlo al valor numérico
  if (typeof priceCalculationType === 'string') {
    return EnumPriceCalculationType[priceCalculationType as keyof typeof EnumPriceCalculationType]
  }

  return undefined
}
